import React, { useState } from 'react';
import { Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core';
import { ColorPaletteDisplay } from "components/explore/gmap/colorHelper";

const PalettePicker = ({ palettes, selectedPaletteId, onPaletteChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  function openPaletteMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function closePaletteMenu() {
    setAnchorEl(null);
  }

  function handleChangeColorPalette(palette) {
    onPaletteChange(palette.id);
    closePaletteMenu();
  }

  return (
    <>
      <Tooltip title='Change palette' placement='bottom'>
        <IconButton 
          // className={classes.actionButton}
          onClick={openPaletteMenu}
          style={{
            padding: 4,
            // marginLeft: 2
          }}
          >
            {/* <PaletteIcon /> */}
            <ColorPaletteDisplay palette={palettes.find(palette => palette.id === selectedPaletteId)} />
        </IconButton>
      </Tooltip>
      <Menu
        id="quick-filters"
        anchorEl={anchorEl}
        transformOrigin={{
          vertical: -32,
          horizontal: 'left'
        }}
        open={Boolean(anchorEl)}
        keepMounted
        onClose={closePaletteMenu}>
          {/* <div className={classes.invertToggleContainer}>
            <Switch
              checked={shouldInvertPalette}
              onChange={e => setShouldInvertPalette(e.target.checked)}
              name="locationToggle"
              color="secondary"
            />
            <Typography>Invert palette</Typography>
            <Tooltip
              title={"Apply the saved filter's original center and zoom level"}
            >
              <InfoIcon className={classes.tooltipIcon}/>
            </Tooltip>
          </div> 
          <Divider key={'divider'} className={classes.divider}/> */}
          {palettes.map(palette => {
            return (
              <MenuItem
                key={palette.id}
                selected={palette.id === selectedPaletteId}
                onClick={() => handleChangeColorPalette(palette)} 
              >
                <ColorPaletteDisplay palette={palette} />
              </MenuItem>
            )
          })}
          {/* {otherSavedFilters.map(f => {
            return (
              <MenuItem
                key={f.id}
                selected={false}
                onClick={()=>{loadFilter(f)}} 
                className={classes.dropDownItem}
              >
                {f.name}
              </MenuItem>
            )
          })}  */}
      </Menu>
    </>
  )
}

export default PalettePicker;